module.exports = __webpack_public_path__ + "apple-pay.ac81cbca0f467e9981e321938d1f3885.svg";